import { render, staticRenderFns } from "./ColorBox.vue?vue&type=template&id=28c7ebee&"
import script from "./ColorBox.vue?vue&type=script&lang=js&"
export * from "./ColorBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports